/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import axios from 'axios';

import { opinConsentPage as OCP } from '../const';
import Home from '../home';

export default function AuthConsent() {
  const [cmdAuth, setCmdAuth] = useState();
  const { hash } = useLocation();
  const commandId = hash?.replace('#', '');

  const api = axios.create({
    baseURL: OCP.baseURL,
  });

  const getConsent = useCallback(async () => {
    await api
      .get(`/auth/app/commands/${commandId}`)
      .then((response) => {
        setCmdAuth(response.data);
        localStorage.setItem('commandId', commandId);
      })
      .catch((error) => {
        // navigate('/home');
        return error;
      });
  }, []);

  useEffect(() => {
    localStorage.clear();
    getConsent();
  }, []);

  return cmdAuth ? <Home cmdAuth={cmdAuth} /> : null;
}
